<template>
	<div class="GSJJ">
		<div class="content gs">
			<div class="content_2 c3 lh7">
				<div class="f30">公司简介</div>
				<div class="f20 mb45">COMPANY PROFILE</div>
				<div class="f18 mb45">
					大众物流成立于2001年7月，注册资金3500万，拥有各类车辆350台，在职员工4000余人。公司本部占地面积11万平方米。是国家级高新技术企业和吉林省科技小巨人企业。</div>
				<div class="f18 mb45">
					大众物流是智慧型、科技型综合物流服务企业，专业从事物流软硬件开发和系统集成，专注于物流管理信息系统、智能化立体仓库及自动化设备制造，为客户提供端到端的全程一站式物流管理和定制化服务。作为汽车智能物流技术应用的先行者、互联网+汽车物流模式的推动者以及汽车供应链生态圈的规划和组织者，致力于智能汽车物流供应链的建设，打造高科技物流企业新标杆。
				</div>

				<div class="f18 mb45">
					大众物流是由资深的供应链管理、物流运营、信息技术专家组建的智慧型、科技型综合物流服务企业，下设有杭州裕新智能科技有限公司等运营实体及研发机构，专业从事物流软硬件开发和系统集成，专注于物流管理信息系统、智能化立体仓库及自动化设备制造，为客户提供端到端的全程一站式物流管理和定制化服务。
				</div>
			</div>
		</div>
		<div class="sx pr tz" id="pic1" :style="{'background-position-y': positionY1+'px' }">
			<img class="sx_img" src="../../assets/About_item_2.png" />
			<img src="../../assets/About_item_1.jpg" class="dn" @load="load" />
		</div>
		<div class="content ys">
			<div class="content_2 c3 lh7">
				<!-- <div class="f30">公司优势</div>
				<div class="f20 mb45">THE COMPANY ADVANTAGE</div> -->
				<div>
					<div class="ys_item tran1">
						<div class="bimg tran3">
							<el-image class="tran3" style="width: 100%; height: 100%" :src="require('@/assets/About_item_4.jpg')" :fit="'cover'"></el-image>
						</div>
						<div class="info">
							<div class="f24 mb15">
								<!-- 行业闭环商业模型 -->企业愿景
							</div>
							<div class="f18 hang3">
								<!-- 新零售“线上-线下-物流”三要素模型的嵌入，与“人、仓、车”行业三要素的紧密配合，将最难解决的行业人才获取下沉到专业学校开课和创办“好饭碗”一站式工作平台。 -->成为国内一流的科技型物流公司。
							</div>
						</div>
					</div>
					<div class="ys_item tran1">
						<div class="bimg tran3">
							<el-image class="tran3" style="width: 100%; height: 100%" :src="require('@/assets/About_item_3.jpg')" :fit="'cover'"></el-image>
						</div>
						<div class="info">
							<div class="f24 mb15">
								<!-- 技术和设备创新 -->核心价值观
							</div>
							<div class="f18 hang3">
								<!-- 100%自主研发WMS、TMS、OCS系统和HRS、HFW、WHY等管理平台，仓车人运配一体化定制服务；货到人密集存储与AGV存储分拣系统，提高4倍的存储效率和3倍的分拣效率，达到国内最高水平。悬挂链合流系统取得颠覆性效果。 -->以人为本
								、管理创新、持续优化、精益服务。
							</div>
						</div>
					</div>
					<div class="ys_item tran1">
						<div class="bimg tran3">
							<el-image class="tran3" style="width: 100%; height: 100%" :src="require('@/assets/About_item_5.jpg')" :fit="'cover'"></el-image>
						</div>
						<div class="info">
							<div class="f24 mb15">
								<!-- 团队发展理念 -->企业作风
							</div>
							<div class="f18 hang3">
								<!-- 多达数十个不同工种和职业阶段的职业培训，横向纵向的职业发展，优秀经理人合伙人制度的执行，以及普惠员工的上嘉服务链的建设，真正用互联网思维将行业的优质员工吸引到平台。创办“好饭碗”一站式工作平台。 -->专业专注、全心服务。
							</div>
						</div>
					</div>
					<div class="cl"></div>
				</div>
			</div>
		</div>
		<div style="background-color: #ebeef0;">
			<div class="content kh">
				<div class="content_2 pr c3">
					<div class="f30 lh7">主要客户</div>
					<div class="f20 mb45 lh7">MAJOR CUSTOMERS</div>
					<div class="kh_content mtb50">
						<div class="kh_item" v-for="(item,i) in items" :class="{'kh_item_2': i%2!=0}">{{item}}</div>
						<div class="cl"></div>
					</div>
					<div class="num vn">
						<div class="mb30">
							<span class="f36">10</span>
							<span class="f20 c6">个覆盖省份</span>
							<span class="k"></span>
							<span class="f36">500+</span>
							<span class="f20 c6">辆运输车辆</span>
						</div>
						<div class="">
							<span class="f36">12</span>
							<span class="f20 c6">个覆盖城市</span>
							<span class="k"></span>
							<span class="f36">2000+</span>
							<span class="f20 c6">名工人数</span>
						</div>
					</div>
					<div class="img">
						<!-- <img src="../../assets/About_item_6.png" /> -->
						<div id="china" ref="china"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import echarts from "echarts";
	import "@/assets/js/china.js"; // 引入中国地图数据
	export default {
		data() {
			return {
				positionY1: 0,
				Y1: 0,
				ratio: 0.4,
				items: [
					'一汽集团红旗蔚山工厂',
					'一汽红旗国产化异地供应商',
					'一汽集团动力总成工厂',
					'中车长春轨道客车',
					'红旗蔚山工厂仓储配送中心',
					'一汽无锡柴油机厂',
					'一汽解放青岛',
					'长城汽车徐水工厂',
					'天际汽车长沙基地',
				],
				china: '',
			}
		},
		mounted() {
			window.addEventListener("scroll", this.handleScroll);
			window.addEventListener('resize', this.onWindowResize, false);
			this.$nextTick(() => {
				setTimeout(() => {
					this.initMap()
				}, 300)
			})
		},
		unmounted() {
			window.removeEventListener('scroll', this.handleScroll)
			window.removeEventListener('resize', this.onWindowResize)
			try {
				this.china.dispose()
			} catch (e) {}
		},
		methods: {
			initMap() {
				this.china = echarts.init(this.$refs.china);
				// 全国省份列表
				var dataMap = [{
					name: '吉林',
					selected: true,
					value: 100
				}];
				// var dataValue = this.dealWithData();
				var dataMine = [{
					name: '长春',
					value: [125.35, 43.88]
				}];
				var dataOther = [{
						name: '青岛',
						value: [120.33, 36.07]
					},
					{
						name: '保定',
						value: [115.48, 38.85]
					},
					{
						name: '无锡',
						value: [120.29, 31.59]
					},
					{
						name: '长沙',
						value: [113, 28.21]
					},
					{
						name: '绍兴',
						value: [120.58, 30.01]
					},
					{
						name: '潍坊',
						value: [119.1, 36.62]
					},
					{
						name: '成都',
						value: [104.06, 30.67]
					},
				];
				var bg = 'rgba(1, 72, 152, 0.9)';
				var border = 'rgb(178, 183, 194)';
				var yellow = 'rgb(255, 154, 38)';
				var ff = '#fff';
				var planePath =
					'path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z';
				var getCoords = () => {
					let dataLines = [];
					dataOther.forEach(x => {
						dataLines.push({
							coords: [
								[125.35, 43.88],
								[x.value[0], x.value[1]]
							]
						})
					})
					return dataLines
				};
				var coords = getCoords();
				var option = {
					geo: {
						map: "china",
						roam: false, // 一定要关闭拖拽
						zoom: 1.18,
						center: [105, 36], // 调整地图位置
						label: {
							normal: {
								show: false, //关闭省份名展示
								fontSize: "10",
								color: "rgba(0,0,0,0.3)"
							},
							emphasis: {
								show: false
							}
						},
						itemStyle: {
							normal: {
								areaColor: bg,
								borderColor: border,
								borderWidth: 1, //设置外层边框
								shadowBlur: 5,
								shadowOffsetY: 8,
								shadowOffsetX: 0,
								shadowColor: "rgba(0,0,0,0.3)"
							}
						},
						silent: true, //关闭鼠标交互
					},
					//配置属性
					series: [{
							type: "map",
							map: "china",
							roam: false,
							zoom: 1.18,
							center: [105, 36],
							// geoIndex: 1,
							// aspectScale: 0.75, //长宽比
							showLegendSymbol: false, // 存在legend时显示
							label: {
								normal: {
									show: false,
									color: '#fff'
								},
								emphasis: {
									show: false,
									color: "#333"
								}
							},
							itemStyle: {
								normal: {
									areaColor: '#f7f7f7',
									borderColor: border,
									borderWidth: 0.5
								},
								emphasis: {
									areaColor: ff,
									shadowOffsetX: 0,
									shadowOffsetY: 5,
									shadowBlur: 10,
									borderWidth: 0,
									shadowColor: "rgba(0, 0, 0, 0.3)"
								}
							},
							silent: true, //关闭鼠标交互
							data: dataMap
						}, {
							name: "Other",
							type: "scatter", //散点
							coordinateSystem: "geo",
							data: dataOther,
							// symbolSize: function(val) {
							// 	return val[2] / 10;
							// },
							symbol: "circle",
							symbolSize: 4,
							hoverSymbolSize: 5,
							tooltip: {
								formatter(value) {
									return value.data.name + "<br/>" + "设备数：" + "22";
								},
								show: true
							},
							encode: {
								value: 2
							},
							label: {
								normal: {
									formatter: "{b}",
									position: "right",
									show: false,
									fontSize: 14,
								},
							},
							itemStyle: {
								normal: {
									color: bg,
								},
							},
							emphasis: {
								label: {
									show: false
								}
							},
							zlevel: 20,
						},
						{
							name: "Mine",
							type: "effectScatter", //涟漪
							coordinateSystem: "geo",
							data: dataMine,
							symbolSize: 14,
							tooltip: {
								show: false
							},
							encode: {
								value: 2
							},
							showEffectOn: "render",
							rippleEffect: {
								brushType: "stroke",
								color: bg,
								period: 9,
								scale: 5
							},
							hoverAnimation: true,
							label: {
								normal: {
									formatter: "{b}",
									position: "right",
									fontSize: 14,
									show: true
								}
							},
							itemStyle: {
								normal: {
									color: bg,
									shadowBlur: 3,
									shadowOffsetY: 3,
									shadowOffsetX: 0,
									shadowColor: "rgba(0,0,0,0.15)"
								}
							},
							zlevel: 20
						},
						{
							name: 'Lines',
							type: 'lines',
							symbol: ['none'],
							symbolSize: 10,
							// effect: {
							// 	show: true,
							// 	period: 6,
							// 	trailLength: 0,
							// 	symbol: planePath,
							// 	symbolSize: 15
							// },
							lineStyle: {
								normal: {
									color: ff,
									width: 2,
									opacity: 0.8,
									curveness: 0.2
								}
							},
							zlevel: 5,
							data: coords
						},
						{
							name: 'Lines2',
							type: 'lines',
							symbol: ['none'],
							symbolSize: 10,
							effect: {
								show: true,
								period: 3,
								// constantSpeed: 40, //速度
								trailLength: 0.9, //尾迹
								color: bg,
								symbolSize: 2
							},
							lineStyle: {
								normal: {
									color: ff,
									width: 2,
									opacity: 0,
									curveness: 0.2
								}
							},
							zlevel: 10,
							data: coords
						}
					]
				};

				this.china.setOption(option);
			},
			dealWithData() {
				var geoCoordMap = {
					// 海门: [121.15, 31.89],
					// 鄂尔多斯: [109.781327, 39.608266],
					// 招远: [120.38, 37.35],
					// 舟山: [122.207216, 29.985295],
					// 齐齐哈尔: [123.97, 47.33],
					// 盐城: [120.13, 33.38],
					// 赤峰: [118.87, 42.28],
					// 青岛: [120.33, 36.07],
					// 乳山: [121.52, 36.89],
					// 金昌: [102.188043, 38.520089],
					// 泉州: [118.58, 24.93],
					// 莱西: [120.53, 36.86],
					// 日照: [119.46, 35.42],
					// 胶南: [119.97, 35.88],
					// 南通: [121.05, 32.08],
					// 拉萨: [91.11, 29.97],
					// 云浮: [112.02, 22.93],
					// 梅州: [116.1, 24.55],
					// 文登: [122.05, 37.2],
					// 上海: [121.48, 31.22],
					// 攀枝花: [101.718637, 26.582347],
					// 威海: [122.1, 37.5],
					// 承德: [117.93, 40.97],
					// 厦门: [118.1, 24.46],
					// 汕尾: [115.375279, 22.786211],
					// 潮州: [116.63, 23.68],
					// 丹东: [124.37, 40.13],
					// 太仓: [121.1, 31.45],
					// 曲靖: [103.79, 25.51],
					// 烟台: [121.39, 37.52],
					// 福州: [119.3, 26.08],
					// 瓦房店: [121.979603, 39.627114],
					// 即墨: [120.45, 36.38],
					// 抚顺: [123.97, 41.97],
					// 玉溪: [102.52, 24.35],
					// 张家口: [114.87, 40.82],
					// 阳泉: [113.57, 37.85],
					// 莱州: [119.942327, 37.177017],
					// 湖州: [120.1, 30.86],
					// 汕头: [116.69, 23.39],
					// 昆山: [120.95, 31.39],
					// 宁波: [121.56, 29.86],
					// 湛江: [110.359377, 21.270708],
					// 揭阳: [116.35, 23.55],
					// 荣成: [122.41, 37.16],
					// 连云港: [119.16, 34.59],
					// 葫芦岛: [120.836932, 40.711052],
					// 常熟: [120.74, 31.64],
					// 东莞: [113.75, 23.04],
					// 河源: [114.68, 23.73],
					// 淮安: [119.15, 33.5],
					// 泰州: [119.9, 32.49],
					// 南宁: [108.33, 22.84],
					// 营口: [122.18, 40.65],
					// 惠州: [114.4, 23.09],
					// 江阴: [120.26, 31.91],
					// 蓬莱: [120.75, 37.8],
					// 韶关: [113.62, 24.84],
					// 嘉峪关: [98.289152, 39.77313],
					// 广州: [113.23, 23.16],
					// 延安: [109.47, 36.6],
					// 太原: [112.53, 37.87],
					// 清远: [113.01, 23.7],
					// 中山: [113.38, 22.52],
					// 昆明: [102.73, 25.04],
					// 寿光: [118.73, 36.86],
					// 盘锦: [122.070714, 41.119997],
					// 长治: [113.08, 36.18],
					// 深圳: [114.07, 22.62],
					// 珠海: [113.52, 22.3],
					// 宿迁: [118.3, 33.96],
					// 咸阳: [108.72, 34.36],
					// 铜川: [109.11, 35.09],
					// 平度: [119.97, 36.77],
					// 佛山: [113.11, 23.05],
					// 海口: [110.35, 20.02],
					// 江门: [113.06, 22.61],
					// 章丘: [117.53, 36.72],
					// 肇庆: [112.44, 23.05],
					// 大连: [121.62, 38.92],
					// 临汾: [111.5, 36.08],
					// 吴江: [120.63, 31.16],
					// 石嘴山: [106.39, 39.04],
					// 沈阳: [123.38, 41.8],
					// 苏州: [120.62, 31.32],
					// 茂名: [110.88, 21.68],
					// 嘉兴: [120.76, 30.77],
					// 长春: [125.35, 43.88],
					// 胶州: [120.03336, 36.264622],
					// 银川: [106.27, 38.47],
					// 张家港: [120.555821, 31.875428],
					// 三门峡: [111.19, 34.76],
					// 锦州: [121.15, 41.13],
					// 南昌: [115.89, 28.68],
					// 柳州: [109.4, 24.33],
					// 三亚: [109.511909, 18.252847],
					// 自贡: [104.778442, 29.33903],
					// 吉林: [126.57, 43.87],
					// 阳江: [111.95, 21.85],
					// 泸州: [105.39, 28.91],
					// 西宁: [101.74, 36.56],
					// 宜宾: [104.56, 29.77],
					// 呼和浩特: [111.65, 40.82],
					// 成都: [104.06, 30.67],
					// 大同: [113.3, 40.12],
					// 镇江: [119.44, 32.2],
					// 桂林: [110.28, 25.29],
					// 张家界: [110.479191, 29.117096],
					// 宜兴: [119.82, 31.36],
					// 北海: [109.12, 21.49],
					// 西安: [108.95, 34.27],
					// 金坛: [119.56, 31.74],
					// 东营: [118.49, 37.46],
					// 牡丹江: [129.58, 44.6],
					// 遵义: [106.9, 27.7],
					// 绍兴: [120.58, 30.01],
					// 扬州: [119.42, 32.39],
					// 常州: [119.95, 31.79],
					// 潍坊: [119.1, 36.62],
					// 重庆: [106.54, 29.59],
					// 台州: [121.420757, 28.656386],
					// 南京: [118.78, 32.04],
					// 滨州: [118.03, 37.36],
					// 贵阳: [106.71, 26.57],
					// 无锡: [120.29, 31.59],
					// 本溪: [123.73, 41.3],
					// 克拉玛依: [84.77, 45.59],
					// 渭南: [109.5, 34.52],
					// 马鞍山: [118.48, 31.56],
					// 宝鸡: [107.15, 34.38],
					// 焦作: [113.21, 35.24],
					// 句容: [119.16, 31.95],
					// 北京: [116.46, 39.92],
					// 徐州: [117.2, 34.26],
					// 衡水: [115.72, 37.72],
					// 包头: [110, 40.58],
					// 绵阳: [104.73, 31.48],
					// 乌鲁木齐: [87.68, 43.77],
					// 枣庄: [117.57, 34.86],
					// 杭州: [120.19, 30.26],
					// 淄博: [118.05, 36.78],
					// 鞍山: [122.85, 41.12],
					// 溧阳: [119.48, 31.43],
					// 库尔勒: [86.06, 41.68],
					// 安阳: [114.35, 36.1],
					// 开封: [114.35, 34.79],
					// 济南: [117, 36.65],
					// 德阳: [104.37, 31.13],
					// 温州: [120.65, 28.01],
					// 九江: [115.97, 29.71],
					// 邯郸: [114.47, 36.6],
					// 临安: [119.72, 30.23],
					// 兰州: [103.73, 36.03],
					// 沧州: [116.83, 38.33],
					// 临沂: [118.35, 35.05],
					// 南充: [106.110698, 30.837793],
					// 天津: [117.2, 39.13],
					// 富阳: [119.95, 30.07],
					// 泰安: [117.13, 36.18],
					// 诸暨: [120.23, 29.71],
					// 郑州: [113.65, 34.76],
					// 哈尔滨: [126.63, 45.75],
					// 聊城: [115.97, 36.45],
					// 芜湖: [118.38, 31.33],
					// 唐山: [118.02, 39.63],
					// 平顶山: [113.29, 33.75],
					// 邢台: [114.48, 37.05],
					// 德州: [116.29, 37.45],
					// 济宁: [116.59, 35.38],
					// 荆州: [112.239741, 30.335165],
					// 宜昌: [111.3, 30.7],
					// 义乌: [120.06, 29.32],
					// 丽水: [119.92, 28.45],
					// 洛阳: [112.44, 34.7],
					// 秦皇岛: [119.57, 39.95],
					// 株洲: [113.16, 27.83],
					// 石家庄: [114.48, 38.03],
					// 莱芜: [117.67, 36.19],
					// 常德: [111.69, 29.05],
					// 保定: [115.48, 38.85],
					// 湘潭: [112.91, 27.87],
					// 金华: [119.64, 29.12],
					// 岳阳: [113.09, 29.37],
					// 长沙: [113, 28.21],
					// 衢州: [118.88, 28.97],
					// 廊坊: [116.7, 39.53],
					// 菏泽: [115.480656, 35.23375],
					// 合肥: [117.27, 31.86],
					// 武汉: [114.31, 30.52],
					// 大庆: [125.03, 46.58]
				};
				var data = [];
				for (var key in geoCoordMap) {
					data.push({
						name: key,
						value: geoCoordMap[key]
					});
				}
				return data;
			},
			load() {
				this.$nextTick(() => {
					let pic1 = document.getElementById("pic1");
					this.positionY1 = this.Y1 = pic1.offsetTop * this.ratio;
					// console.log(this.positionY1)
				})
			},
			onWindowResize() {
				let pic1 = document.getElementById("pic1");
				this.positionY1 = this.Y1 = pic1.offsetTop * this.ratio;
				this.china.resize()
			},
			handleScroll() {
				if (!this.$store.state.mobile) {
					let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
					this.positionY1 = this.Y1 - scrollTop * this.ratio; //原始高度-滚动距离*视差系数
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/theme.scss';

	.GSJJ {
		.gs {
			padding-top: 65px;

			.f18 {
				text-indent: 36px;
			}

			@media screen and (max-width: 768px) {
				.f30 {
					font-size: 7vw;
					line-height: 1.2;
					text-align: center;
					margin-bottom: 20px;
				}

				.f20 {
					font-size: 16px;
					text-align: center;
					line-height: 1.2;
					margin-bottom: 30px;
				}

				.f18 {
					font-size: 4.6vw;
					text-align: justify;
				}

				padding-left: 4vw;
				padding-right: 4vw;
				box-sizing: border-box;
			}

		}

		.sx {
			height: 400px;
			background-image: url(../../assets/About_item_1.jpg);
			background-repeat: no-repeat;
			background-position-x: center;
			background-attachment: fixed;

			@media screen and (max-width: 768px) {
				background-attachment: inherit;
				background-size: cover;
				display: flex;
				align-items: center;
				justify-content: center;
				height: auto;
				padding: 6vw 0;
				background-position-y: 0px !important;
			}
		}

		.sx_img {
			margin-top: 30px;

			@media screen and (max-width: 768px) {
				width: 96%;
				margin: 0;
			}
		}

		.ys {
			padding-top: 65px;
			margin-bottom: 75px;

			.ys_item {
				float: left;
				width: 30%;
				margin-left: 5%;
				border: 2px solid #cfcfcf;
				border-radius: 2px;
				overflow: hidden;
				box-sizing: border-box;
				height: 440px;

				&:first-of-type {
					margin-left: 0;
				}

				.bimg {
					height: 280px;
					overflow: hidden;
				}
				
				img {
					transition: all 0.3s;
					-webkit-transition: all 0.3s;
				}

				.info {
					height: auto;
					padding: 30px;
					box-sizing: border-box;
				}

				&:hover {
					background-color: $blue;
					color: #FFFFFF;

					.bimg {
						// height: 190px;
						// background-size: 105%;
					}
					
					.el-image {
						transform: scale(1.05);
						-webkit-transform: scale(1.05);
					}

					.hang3 {
						display: inline-block;
						text-overflow: initial;
					}
				}

				@media screen and (max-width: 768px) {
					float: none;
					width: 100%;
					margin: 0 0 2vw;
					border-width: 1px;

					background-color: #FFFFFF !important;
					color: #333 !important;

					height: auto;

					.info {
						height: auto;
					}

					.bimg {
						height: 190px;
					}

					.hang3 {
						display: inline-block;
						text-overflow: initial;
					}

					.f18 {
						font-size: 16px;
					}
				}
			}

			@media screen and (max-width: 768px) {
				padding-left: 2vw;
				padding-right: 2vw;
				box-sizing: border-box;
				margin-bottom: 65px;
			}
		}

		.kh {
			padding-top: 65px;
			padding-bottom: 65px;

			.kh_content {
				width: 535px;

				.kh_item {
					float: left;
					line-height: 44px;
					text-align: center;
					width: 260px;
					box-sizing: border-box;
					border: 1px solid #cbcccc;
					// background-color: #f3f4f5;
					background-color: #fff;
					margin: 0 15px 12px 0;

					@media screen and (max-width: 768px) {
						float: none;
						width: 100%;
					}
				}

				.kh_item_2 {
					margin-right: 0;
				}

				@media screen and (max-width: 768px) {
					margin: 20px 0;
					width: 100%;
				}
			}

			.num {
				padding-left: 50px;

				@media screen and (max-width: 768px) {
					display: none;
				}

				.k {
					width: 120px;
					display: inline-block;
				}
			}

			.img {
				position: absolute;
				right: 0;
				top: 0;
				bottom: 0;
				text-align: right;

				img {
					height: 100%;
				}

				#china {
					height: 100%;
					width: 40vw;
					position: relative;

					// @media screen and (max-width: 1570px) {
					// 	width: 40vw;
					// }

					@media screen and (max-width: 768px) {
						width: 100%;
					}
				}

				@media screen and (max-width: 768px) {
					position: inherit;
					height: 400px;
				}
			}

			@media screen and (max-width: 768px) {
				.f30 {
					font-size: 7vw;
					line-height: 1.2;
					text-align: center;
					margin-bottom: 20px;
				}

				.f20 {
					font-size: 16px;
					text-align: center;
					line-height: 1.2;
					margin-bottom: 30px;
				}

				.f18 {
					font-size: 16px;
				}

				padding-left: 2vw;
				padding-right: 2vw;
				box-sizing: border-box;
			}
		}
	}
</style>
